var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.001,
    height: 14.958,
    viewBox: "0 0 24.001 14.958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-344.5 -492.521)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1406.949 -648.014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1757.68 1143.118)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.639,
    cy: 5.639,
    r: 5.639,
    transform: "translate(0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1761.064 1146.502)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.256,
    cy: 2.256,
    r: 2.256,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1783.517,1140.534l-15.276,14.07.818.888,15.319-14.023Z",
    transform: "translate(-13.417)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.952,1177.773a4.508,4.508,0,0,0,4.012-6.57l-6.416,5.873A4.484,4.484,0,0,0,1800.952,1177.773Z",
    transform: "translate(-37.633 -24.504)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.573,1159a4.509,4.509,0,0,0-3.468,7.394l6.644-6.083A4.5,4.5,0,0,0,1792.573,1159Z",
    transform: "translate(-29.253 -14.752)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1783.578,1159.026a4.509,4.509,0,0,1,7.688-3.2l.832-.761a5.635,5.635,0,0,0-8.308,7.6l.832-.761A4.491,4.491,0,0,1,1783.578,1159.026Z",
    transform: "translate(-24.77 -10.268)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1801.565,1168.09a4.508,4.508,0,0,1-6.416,5.873l-.855.783a5.635,5.635,0,0,0,8.127-7.439Z",
    transform: "translate(-34.233 -21.391)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807.487,1181.969a2.248,2.248,0,0,0,2.823-2.584Z",
    transform: "translate(-44.774 -31.042)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1844.17,1164.42a27.418,27.418,0,0,0-5.808-3.736l-.905.828a25.736,25.736,0,0,1,6,3.78Z",
    transform: "translate(-68.72 -16.099)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1806.023,1175.831a1.129,1.129,0,0,0-1.128,1.128,1.116,1.116,0,0,0,.167.587l1.63-1.492A1.12,1.12,0,0,0,1806.023,1175.831Z",
    transform: "translate(-42.703 -28.202)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.412,1172.476a1.126,1.126,0,0,1,1.8-.905l.837-.767a2.251,2.251,0,0,0-3.306,3.026l.838-.767A1.116,1.116,0,0,1,1800.412,1172.476Z",
    transform: "translate(-38.22 -23.719)",
    fill: "#0d1c4b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.21,1153.559a15.206,15.206,0,0,0-7.206-.944,14.923,14.923,0,0,0-9.555,5.376l.9.674a14.027,14.027,0,0,1,8.8-4.932,13.842,13.842,0,0,1,6.113.687",
    transform: "translate(0 -9.571)",
    fill: "#0d1c4b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDash);
export default __webpack_public_path__ + "static/media/eye-dash.8c4f405d856e9a3592f055566bce8c5a.svg";
export { ForwardRef as ReactComponent };